import React, { Component } from 'react'
import { observer } from 'mobx-react/index'
import object_value from '../api/object_value'
import { computed } from "mobx"

@observer
class ResultsInnerExperienceUser extends Component {
  @computed get user() {
    return this.props.experience_user
  }

  render () {
    let experience_user = this.user.data

    if (!this.user.loaded) {
      return (<div />)
    }

    let surname = experience_user.surname ? experience_user.surname.charAt(0) + '.' : ''
    let name = experience_user.prename + ' ' + surname

    let image_url = experience_user.image_url
    let image_style = image_url
      ? { backgroundImage: 'url(' + image_url + ')' }
      : {}

    return (
      <div className='b-experiences-experience-author'>
        <div className='b-experiences-experience-author-picture'
             style={image_style} />
        <div className='b-experiences-experience-author-name'>{name}</div>
      </div>
    )
  }
}

export default ResultsInnerExperienceUser


// WEBPACK FOOTER //
// ./src/components/ResultsInnerExperienceUser.js